import { AsyncCombobox, Label, TOUCH } from "@nymbl/nos2-rules";
import { useId, useState } from "react";
import type { ExpensePoOption } from "@/schemas/expenses";

const searchable = (p: ExpensePoOption) =>
  `${p.label} ${p.department} ${p.isDemand ? "demand" : ""}`.toLowerCase();

const optionText = (p: ExpensePoOption) =>
  `${p.label} · ${p.isDemand ? "Demand PO" : p.department}`;

interface PoPickerProps {
  /** Already narrowed to the claim's year. */
  pos: ExpensePoOption[];
  value: string;
  invalid: boolean;
  onChange: (id: string) => void;
}

/** The PO of a Department POs claim: searchable by number, name, department or "demand". */
export function PoPicker({ pos, value, invalid, onChange }: PoPickerProps) {
  const id = useId();
  const [search, setSearch] = useState("");
  const selected = pos.find((p) => p.id === value);
  const term = search.trim().toLowerCase();
  const shown = term === "" ? pos : pos.filter((p) => searchable(p).includes(term));
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id}>Purchase order</Label>
      <AsyncCombobox
        id={id}
        className={TOUCH}
        value={value || null}
        onChange={(id) => onChange(id)}
        options={shown}
        getOptionValue={(p) => p.id}
        getOptionLabel={(p) => (
          <span className="flex flex-col">
            <span>{p.label}</span>
            <span className="text-xs text-muted-foreground">
              {p.isDemand ? `Demand PO, ${p.department}` : p.department}
            </span>
          </span>
        )}
        getOptionText={optionText}
        selectedLabel={selected ? optionText(selected) : undefined}
        search={search}
        onSearchChange={setSearch}
        placeholder={
          pos.length === 0 ? "No purchase orders for this year" : "Pick a purchase order"
        }
        searchPlaceholder="Search number, name or department"
        emptyText="No matches"
        invalid={invalid && value === ""}
      />
    </div>
  );
}
